import { useEffect, useRef, useState } from "react";

/* Visina tabele koja se zavrsava na dnu ekrana.
 *
 * Visina se RACUNA, ne pogadja. Iznad tabele stoji promenljiva visina —
 * zaglavlje aplikacije, kartice modula i traka sa izborom kolona, koja se
 * prelomi u dva reda kad je izabrano vise kolona, a na mobilnom se slaze
 * uspravno. Fiksna vrednost (npr. 600px) je zato na malom ekranu probijala dno,
 * a na velikom ostavljala prazan prostor ispod spiska.
 *
 * Meri se gde tabela stvarno pocinje, pa se od visine prozora oduzme to i njeno
 * sopstveno podnozje. Racuna se pri montiranju, na promenu velicine prozora i
 * na svaku prosledjenu zavisnost (npr. izbor kolona) koja pomera tabelu.
 *
 * Koristi se ovako:
 *   const [omotTabele, visinaTabele] = useVisinaTabele([selectedColumns, izabran]);
 *   <div ref={omotTabele}><DataTable scrollHeight={visinaTabele} ... /></div>
 *
 * podnozje: zaglavlje tabele i paginator su UNUTAR tabele, a scrollHeight vazi
 * samo za telo — zato se oduzimaju, uz mali predah do ivice ekrana. Tabela bez
 * paginatora ili bez zaglavlja prosledjuje manju vrednost.
 */
export default function useVisinaTabele(zavisnosti = [], podnozje = 112) {
    const omot = useRef(null);
    /* Do prvog merenja stoji razumna vrednost — da tabela ne trepne od nule. */
    const [visina, setVisina] = useState("60vh");

    useEffect(() => {
        const izracunaj = () => {
            const vrh = omot.current?.getBoundingClientRect().top;
            if (vrh == null) return;
            const slobodno = window.innerHeight - vrh - podnozje;
            /* Donja granica: na niskom prozoru tabela sme da izadje iz okvira,
               ali ne sme da se svede na par piksela i postane neupotrebljiva. */
            setVisina(Math.max(220, Math.round(slobodno)) + "px");
        };

        izracunaj();
        window.addEventListener("resize", izracunaj);
        return () => window.removeEventListener("resize", izracunaj);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [podnozje, ...zavisnosti]);

    return [omot, visina];
}
